<template>
  <PartnerListWidget @click="handleMortgageAffordabilityLinkClicked">
    <template #icon>
      <HgIcon icon="Calculator" size="large" theme="secondary" />
    </template>
    <template #content>
      <span>
        {{ t('integrations.mortgageAffordability.action.text') }}
        <span :class="$style.cta">
          {{ t('integrations.mortgageAffordability.action.link') }}
        </span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import {
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'MortgageAffordability',
});

const { t } = useI18n();

const scrollTo = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleMortgageAffordabilityLinkClicked = (): void => {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_AFFORDABILITY_CALCULATOR,
    h_event_label_008: InteractionContainerName.LINK,
  });
  scrollTo('mortgage-calculator');
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
